// Delay activating a focus trap until the dialog animation is finished
// see https://github.com/focus-trap/focus-trap/blob/master/docs/js/animated-dialog.js
export default function (trapContainers) {
  const results = trapContainers.map((container) => {
    return new Promise((resolve) => {
      const interval = setInterval(() => {
        if (getComputedStyle(container).visibility !== "hidden") {
          resolve();
          clearInterval(interval);
        }
      }, 5);
    });
  });
  // Return a promise that resolves when all the trap containers are able to receive focus
  return Promise.all(results);
}
